import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[select-all-on-focus]",
  standalone: false,
})
export class SelectAllOnFocusDirective {
  constructor(private el: ElementRef) {}

  @HostListener("focus") onFocus() {
    const input = this.el.nativeElement as HTMLInputElement;
    if (input) {
      const type = input.type;
      if (input.type === "number") {
        input.type = "text";
      }
      input.setSelectionRange(0, input.value.length);
      if (type === "number") {
        input.type = "number";
      }
    }
  }
}
